import * as React from "react";
import { useLocation, useParams } from "react-router-dom";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { homeLink, linksOf, request } from "../../services/cpln";
import { Loader } from "../../components/layout/loader";
import { RepositoryDetail } from "./repositoryDetail";
import { Image } from "./../../schema/types/image/entity";
import { captureExc } from "../../errorBoundary";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";

type RouteParams = "repository";
export const RepositoryDetailRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  const { pathname } = useLocation();
  const repository = pathname.split(`/console/org/${org}/repository/`)[1];

  const [images, setImages] = React.useState<Image[]>(null as any);
  const [isLoadingImages, setIsLoadingImages] = React.useState(true);
  const [isIncorrectRepository, setIsIncorrectRepository] = React.useState(false);

  React.useEffect(() => {
    fetchItems();
  }, []);

  async function fetchItems() {
    try {
      setIsLoadingImages(true);
      const body = {
        kind: "image",
        spec: {
          match: "all",
          terms: [
            {
              op: "=",
              property: "repository",
              value: repository,
            },
          ],
        },
      };
      const url = homeLink("image") + "/-query";
      const { data } = await request({ method: "post", url: url, body: body });
      let allImages: Image[] = data.items;
      let nextLink = linksOf(data).next;

      while (nextLink) {
        const { data } = await request({ url: nextLink });
        allImages = allImages.concat(data.items);
        nextLink = linksOf(data).next;
      }

      setImages(allImages);
      setIsLoadingImages(false);
    } catch (e) {
      captureExc(e);
      setIsIncorrectRepository(true);
      setIsLoadingImages(false);
    }
  }

  if (isLoadingImages) {
    return <Loader fullScreen />;
  }

  if (isIncorrectRepository) {
    return <IncorrectItem kind={"image"} canCreate={false} />;
  }

  return <RepositoryDetail repository={repository!} images={images} refreshImages={fetchItems} />;
};
